"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  MAX_OFFER_CAROUSEL_ITEMS_COUNT: true,
  MIN_OFFER_SEARCH_ITEMS_COUNT: true,
  OFFER_VALIDITY_VISIBILITY_LIMIT: true,
  CAMPAIGN_OFFER_TYPE: true,
  ERROR_RETRY_COUNT: true,
  ERROR_RETRY_INTERVAL: true,
  SELECTED_OFFER_ITEMS_TOP_LIMIT: true,
  EnableOfferSearchFeatureToggle: true
};
exports.SELECTED_OFFER_ITEMS_TOP_LIMIT = exports.OFFER_VALIDITY_VISIBILITY_LIMIT = exports.MIN_OFFER_SEARCH_ITEMS_COUNT = exports.MAX_OFFER_CAROUSEL_ITEMS_COUNT = exports.EnableOfferSearchFeatureToggle = exports.ERROR_RETRY_INTERVAL = exports.ERROR_RETRY_COUNT = exports.CAMPAIGN_OFFER_TYPE = void 0;
var _defaultTranslations = require("./defaultTranslations");
Object.keys(_defaultTranslations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _defaultTranslations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _defaultTranslations[key];
    }
  });
});
var _constantsGenerated = require("../constants-generated");
Object.keys(_constantsGenerated).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _constantsGenerated[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _constantsGenerated[key];
    }
  });
});
// istanbul ignore file -- constants used in api

const MAX_OFFER_CAROUSEL_ITEMS_COUNT = exports.MAX_OFFER_CAROUSEL_ITEMS_COUNT = 7;
const MIN_OFFER_SEARCH_ITEMS_COUNT = exports.MIN_OFFER_SEARCH_ITEMS_COUNT = 40;
const OFFER_VALIDITY_VISIBILITY_LIMIT = exports.OFFER_VALIDITY_VISIBILITY_LIMIT = 31;
const CAMPAIGN_OFFER_TYPE = exports.CAMPAIGN_OFFER_TYPE = 'CampaignOffer';
const ERROR_RETRY_COUNT = exports.ERROR_RETRY_COUNT = 3;
const ERROR_RETRY_INTERVAL = exports.ERROR_RETRY_INTERVAL = 2000;
const SELECTED_OFFER_ITEMS_TOP_LIMIT = exports.SELECTED_OFFER_ITEMS_TOP_LIMIT = 1000;
const EnableOfferSearchFeatureToggle = exports.EnableOfferSearchFeatureToggle = '1CA55228-6F12-4E84-B5AC-D3F72D8207A6';